import {
  Component,
  Input,
} from "@angular/core";

import { EmployeeProject } from "src/shared/models/employee-project.model";

@Component({
  selector: "[app-tr-project-assignments]",
  templateUrl: "./tr-project-assignments.component.html",
  styleUrls: ["./tr-project-assignments.component.scss"],
})
export class TrProjectAssignments {
  @Input() plan: EmployeeProject = {} as EmployeeProject;

  constructor(
  ) { }

  isEditingDisabled(): boolean {
    return !!this.plan.employeeId;
  }

  inputClicked($event: MouseEvent) {
    $event.stopPropagation();
  }

}